/**
 * Enforces a minimum elapsed time between deployment probes.
 * Prevents redundant HEAD requests during rapid route navigation.
 */
export class DeploymentCheckThrottler {
  private lastCheckAt = 0;
  private readonly minimumGapMs: number;

  constructor(minimumGapMs: number) {
    this.minimumGapMs = minimumGapMs;
  }

  /** Returns true when enough time has passed since the last probe began. */
  canCheck(): boolean {
    if (this.minimumGapMs <= 0) {
      return true;
    }

    if (this.lastCheckAt === 0) {
      return true;
    }

    return Date.now() - this.lastCheckAt >= this.minimumGapMs;
  }

  /** Record that a probe has started. */
  markChecked(): void {
    this.lastCheckAt = Date.now();
  }
}
